<template>
    <article v-if="this.info" :id="this.info.id" class="info-box">
      <h2 class="sub-header">{{ this.info.headline }}</h2>
      <img class="sub-image" :src="this.info.imageUrl" :alt="this.info.imageAlt">
      <div v-html="this.info.content"></div>
    </article>
</template>

<script>
import Info from './../models/info'

export default {
  name: 'InfoBox',
  props: {
    info: Info
  }
}
</script>

<style lang="sass">
.info-box
  padding-top: 0.3em
  margin-bottom: -1em
  ul
    padding-left: 25px
</style>
